<template>
    <transition name="fade">
        <div
            v-if="isShow"
            @click="handleClickOverlay"
            class="vc-overlay"
            id="vueConfirm"
        >
            <transition name="zoom">
                <div v-if="isShow" ref="vueConfirmDialog" class="vc-container card shadow">
                    <div class="card-header big" v-if="dialog.title">
                        <h5 class="card-title" v-html="dialog.title"></h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-io-form">
                            <div class="col-12" v-if="dialog.message">
                                <p class="m-0">
                                    {{ dialog.message }}
                                </p>
                            </div>
                            <div class="col-12" v-if="dialog.html" v-html="dialog.html"></div>
                            <div class="col-12" v-if="dialog.auth">
                                <md-field class="bordered">
                                    <label>Passwort</label>
                                    <md-input
                                        v-model="password"
                                        name="io-confirm-auth"
                                        v-focus
                                        @keyup.13="e => handleClickButton(e, true)"
                                        autocomplete="off"
                                        type="password"
                                    ></md-input>
                                </md-field>
                            </div>
                            <div class="col">
                                <button class="btn btn-outline-dark rounded"
                                        style="min-width: 10em;"
                                        v-if="dialog.button.no"
                                        @click.stop="e => handleClickButton(e, false)"
                                >
                                    {{ dialog.button.no }}
                                </button>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-primary rounded"
                                        v-if="dialog.button.yes"
                                        :disabled="dialog.auth ? !password : false"
                                        @click.stop="e => handleClickButton(e, true)"
                                        style="min-width: 10em;"
                                >
                                    {{ dialog.button.yes }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import { events } from './events';

Vue.directive('focus', {
  inserted(el) {
    el.focus();
  },
});

export default {
  name: 'IoConfirmDialog',

  data() {
    return {
      isShow: false,
      password: null,
      dialog: {
        auth: false,
        title: '',
        message: '',
        html: '',
        button: {},
      },
      params: {},
    };
  },

  methods: {
    resetState() {
      this.password = null;
      this.dialog = {
        auth: false,
        title: '',
        message: '',
        html: '',
        button: {},
        callback: () => {},
      };
    },

    handleClickButton({ target }, confirm) {
      if (target.id === 'vueConfirm') return;
      if (confirm && this.dialog.auth && !this.password) return;

      this.isShow = false;

      if (this.params.callback) {
        this.params.callback(confirm, this.password);
      }
    },

    handleClickOverlay({ target }) {
      if (target.id === 'vueConfirm') {
        this.isShow = false;

        if (this.params.callback) {
          this.params.callback(false, this.password);
        }
      }
    },

    handleKeyUp({ keyCode }) {
      if (keyCode == 27) {
        this.handleClickOverlay({
          target: {
            id: 'vueConfirm',
          },
        });
      }
      if (keyCode == 13) {
        this.handleClickButton({
          target: {
            id: '',
          },
        }, true);
      }
    },
    open(params) {
      this.resetState();
      this.params = params;
      this.isShow = true;

      Object.entries(params).forEach((param) => {
        if (typeof param[1] === typeof this.dialog[param[0]]) {
          this.dialog[param[0]] = param[1];
        }
      });
    },
  },

  mounted() {
    if (!document) return;
    events.$on('open', this.open);
    events.$on('close', () => {
      this.handleClickOverlay({
        target: {
          id: 'vueConfirm',
        },
      });
    });
  },
};
</script>
